module.exports = __webpack_public_path__ + "static/img/pcn.c687996.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/pcn.svg
// module id = DpK4
// module chunks = 0